export default "/_next/static/images/9db900befa5f497ce0cd03ec4afd627d.jpg";